import React from 'react';
import './quote.css';

export default function Quote() {
  return (
    <div className=" pageContainer">
      <p style={{ fontFamily: 'Tangerine', fontSize: '2.5em' }}>
        &quot;Mathematics is not about numbers, equations, computations, or
        algorithms: it is about understanding.&quot;
        <span style={{ fontFamily: 'Tangerine' }}>- Willian Paul Thurtson</span>
      </p>

    </div>
  );
}
